import React from 'react'
import { Button } from 'components/ui'

// Nothing in this app catches render errors, so any uncaught exception
// (e.g. an onChange handler throwing on a specific device/browser) unmounts
// the whole React tree and leaves a blank white screen with no feedback.
// This boundary keeps the shell alive and gives the user a way out.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        console.error('UNCAUGHT RENDER ERROR ->', error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center h-screen gap-4 text-center px-4">
                    <h4>Something went wrong</h4>
                    <p className="text-gray-500">
                        An unexpected error occurred. Reloading the page usually fixes it.
                    </p>
                    <Button variant="solid" onClick={() => window.location.reload()}>
                        Reload
                    </Button>
                </div>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
